export default __webpack_public_path__ + "static/icon-prevent-b0e4718ad815845d40ee93c45a078876.png";